export default __webpack_public_path__ + "static/media/draggableDotsIcon.078894a5.svg";